module.exports = __webpack_public_path__ + "static/media/001-Ueberzeugen_ID_22.ca19ed2b.mp3";